import React from 'react';
import styles from './Contato.module.scss';

import NubankQRCode from '../components/NubankQRCode';

type ContactProps = {
    name: string;
    email: string;
    phone: string;
    address: string;
    photo: string; 
};

export default function Contato({ name, email, phone, address, photo }: ContactProps) {
    return (
        <div className={styles.container}>
            <div className={styles.photoSection}>
                <img src={photo} alt={`${name}'s photo`} className={styles.photo} />
            </div>
            <div className={styles.infoSection}>
                <h1>Contact Me</h1>
                <p><strong>Name:</strong> {name}</p>
                <p><strong>Email:</strong> <a href={`mailto:${email}`}>{email}</a></p>
                <p><strong>Phone:</strong> {phone}</p>
                <p><strong>Address:</strong> {address}</p>

                <NubankQRCode />

            </div>
        </div>
    );
}
